import { Account } from "@/containers/account/Account";

export const Profile = () => {
  return <Account />;
};
